import { Link } from "@tanstack/react-router";
import { Hourglass } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { fr } from "@/i18n/fr";

interface GuideRateLimitedProps {
	/** When the API refused the guide (ms since the epoch). */
	since: number;
	/** `Retry-After` of the 429, in ms. */
	retryAfterMs: number;
	/** Ask for the guide again, once the wait is over. */
	onRetry: () => void;
}

/** A guide refused by the rate limit (RATE_LIMIT_GUIDE): a countdown, then it opens by itself. */
export function GuideRateLimited({
	since,
	retryAfterMs,
	onRetry,
}: GuideRateLimitedProps) {
	const [now, setNow] = useState(Date.now);
	const retry = useRef(onRetry);
	retry.current = onRetry;
	const left = Math.max(0, Math.ceil((since + retryAfterMs - now) / 1000));
	useEffect(() => {
		if (left === 0) {
			retry.current();
			return;
		}
		const timer = setInterval(() => setNow(Date.now()), 250);
		return () => clearInterval(timer);
	}, [left]);
	return (
		<output className="loading">
			<div className="box grid justify-items-center gap-2 text-center">
				<Hourglass className="size-8" strokeWidth={1.25} aria-hidden="true" />
				<b>{fr.guideLimited.title}</b>
				<span aria-live="polite">
					{fr.guideLimited.text(Math.max(left, 1))}
				</span>
				<Link to="/catalogue" className="pill mt-3 no-underline">
					← {fr.catalog}
				</Link>
			</div>
		</output>
	);
}
